import Vue from "vue";

//Event bus for the details page
export const detailsPageEventBus = new Vue();
